import {Injectable} from "@angular/core";
import {SecureStoragePlugin} from 'capacitor-secure-storage-plugin';

import {SecureStorageLocal} from "@app/core/shared/domain/storage/secure-storage.local";

@Injectable()
export class CapacitorSecureLocalStorage implements SecureStorageLocal {
    public async getItem(key: string): Promise<string | null> {
        try {
            const result = await SecureStoragePlugin.get({key});
            return result.value;
        } catch (_) {
            return null;
        }
    }
    public async setItem(key: string, value: string): Promise<void> {
        await SecureStoragePlugin.set({ key, value });
    }
    public async removeItem(key: string): Promise<void> {
        await SecureStoragePlugin.remove({key});
    }
    public async clear(): Promise<void> {
        await SecureStoragePlugin.clear();
    }
}